import { render, staticRenderFns } from "./TablePaging.vue?vue&type=template&id=4c8cd3d7&scoped=true&"
import script from "./TablePaging.vue?vue&type=script&lang=js&"
export * from "./TablePaging.vue?vue&type=script&lang=js&"
import style0 from "./TablePaging.vue?vue&type=style&index=0&id=4c8cd3d7&lang=scss&scoped=true&"
import style1 from "./TablePaging.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8cd3d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c8cd3d7')) {
      api.createRecord('4c8cd3d7', component.options)
    } else {
      api.reload('4c8cd3d7', component.options)
    }
    module.hot.accept("./TablePaging.vue?vue&type=template&id=4c8cd3d7&scoped=true&", function () {
      api.rerender('4c8cd3d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/TablePaging.vue"
export default component.exports